import { nlpIntegration } from '@mi-front/api-clients';

/**
 * Returns the display title for a topic: refined_title when present and non-empty, otherwise canonical_title.
 */
export function getTopicDisplayTitle(topic: nlpIntegration.TopicOutDto): string {
  if (topic.refined_title) {
    return topic.refined_title;
  }

  return topic.canonical_title;
}
